import { render, staticRenderFns } from "./ShowExam.vue?vue&type=template&id=72265b83&scoped=true&"
import script from "./ShowExam.vue?vue&type=script&lang=js&"
export * from "./ShowExam.vue?vue&type=script&lang=js&"
import style0 from "./ShowExam.vue?vue&type=style&index=0&id=72265b83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72265b83",
  null
  
)

export default component.exports